/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Instructions_OptionalInputs */



/**
* | output |
* | --- |
* | "Translation Instructions (Optional)" |
*
* @param {Translation_Instructions_OptionalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_instructions_optional = /** @type {((inputs?: Translation_Instructions_OptionalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Instructions_OptionalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Instructions de traduction (facultatif)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsanweisungen (optional)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Istruzioni di traduzione (facoltativo)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Инструкции для перевода (необязательно)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Instrucciones de traducción (opcional)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译说明（可选）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳の指示（任意）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद निर्देश (वैकल्पिक)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Instruções de tradução (opcional)")
	return /** @type {LocalizedString} */ ("Translation Instructions (Optional)")
});